import React from "react";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-[#0a0a0b] pt-24 pb-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10 mb-16">
          <div className="col-span-2">
            <Logo variant="aiv" />
            <p className="font-body text-sm text-zinc-400 mt-5 max-w-sm leading-relaxed">
              The operating system for the home restoration industry — built for the homeowners who
              need help and the contractors who deliver it.
            </p>
            <div className="mt-6 font-mono-apex text-[10px] uppercase tracking-[0.25em] text-zinc-600">
              www.apexinfinityventures.com
            </div>
          </div>

          {[
            { title: "Platform", items: ["Storm Watch", "Dispatch", "Claims & Docs", "AI Sentinel"] },
            { title: "Apps", items: ["Response Management", { label: "Community Pro", href: "https://apexresponsemgmt.com" }, "Technician", "Business Intelligence"] },
            { title: "Legal", items: ["Privacy", "Terms", "Security", "Disclaimer"] },
          ].map((col) => (
            <div key={col.title}>
              <div className="font-mono-apex text-[10px] uppercase tracking-[0.25em] text-zinc-500 mb-4">
                {col.title}
              </div>
              <ul className="space-y-3">
                {col.items.map((it) => (
                  <li key={it.label || it}>
                    {it.href ? (
                      <a href={it.href} target="_blank" rel="noopener noreferrer" className="font-body text-sm text-zinc-300 hover:text-white transition-colors" data-testid="footer-link-community-pro">
                        {it.label}
                      </a>
                    ) : (
                      <a href="#" className="font-body text-sm text-zinc-300 hover:text-white transition-colors">
                        {it}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row gap-4 justify-between items-start md:items-center">
          <div className="font-mono-apex text-[10px] uppercase tracking-[0.25em] text-zinc-600">
            © {new Date().getFullYear()} Apex Infinity Ventures · All rights reserved
          </div>
          <div className="font-mono-apex text-[10px] uppercase tracking-[0.25em] text-zinc-700 max-w-xl text-left md:text-right">
            Disclaimer: Intelligence outputs are general in nature and do not constitute personalized
            financial, legal, or investment advice.
          </div>
        </div>
      </div>
    </footer>
  );
}
